<template>
  <div class="exr-item flex-column">
    <ImageInput v-model="value.image" :desc.sync="value.imageDesc" img-span="1" input-span="2"></ImageInput>
  </div>
</template>

<script>
import ImageInput from "@/components/ImageInput.vue";

export default {
  name: "PdtItemImage",
  components: {ImageInput},
  props: {
    value: Object,
  }
}
</script>
<style lang="scss" scoped>
.exr-item::v-deep {
  .image-preview {
    border: 0;
    border-right: 1px solid #DCDFE6;
  }
  textarea {
    border: 0;
    height: 81px !important;
    padding-left: 8px;
  }
}
</style>